import type { Verdict } from "../api";

const TONES: Record<
  Verdict,
  { bg: string; fg: string; label: string }
> = {
  proceed: { bg: "var(--ir-sage)", fg: "#fff", label: "Proceed" },
  inform: { bg: "var(--ir-blue)", fg: "#fff", label: "Inform" },
  escalate: { bg: "var(--ir-amber)", fg: "#fff", label: "Escalate" },
  delegate_to_human_pro: {
    bg: "var(--ir-navy)",
    fg: "#fff",
    label: "Delegate to human pro",
  },
};

const baseStyle: React.CSSProperties = {
  display: "inline-block",
  padding: "4px 10px",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.04em",
  borderRadius: 999,
  textTransform: "uppercase",
};

export const VerdictPill = ({ verdict }: { verdict?: Verdict | null }) => {
  if (!verdict) {
    return <span style={{ color: "var(--ir-gray-500)" }}>—</span>;
  }
  const tone = TONES[verdict] ?? {
    bg: "var(--ir-gray-700)",
    fg: "#fff",
    label: verdict,
  };
  return (
    <span style={{ ...baseStyle, background: tone.bg, color: tone.fg }}>
      {tone.label}
    </span>
  );
};
